import { Stack } from "@mui/material";
import ImageTable from "./ImageTable";
import ReportSelector from "./ReportSelector";
import { useEffect, useState } from "react";
import ReportSelector3 from "./ReportsSelector3";
import { useUser } from "../Contexts/UserContext";
import ThreeDotLoader from "./ThreeDotLoader";
import ImageTable3 from "./ImageTable3";
import WashRoomChecklist from "./WashRoomCheckList";
import HourGroupedTable from "./HourGroupedTable";
import HourGroupedTable2 from "./HourGroupedTable2";
import getTodayDate from "./TodaysDate";
import ReportsSelector4 from "./ReportsSelector4";
import ExportToExcelBTN2 from "./ExportToExcelBTN2";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;

const ReportsSummary = () => {
  const [selectedData, setSelectedData] = useState({
    branchObj: null,
    unitObj: null,
    reportObj: null,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [fromDate, setFromDate] = useState(getTodayDate());
  const [toDate, setToDate] = useState(getTodayDate());
  const [tableData, setTableData] = useState([]);
  const [reportsDD, setReportsDD] = useState([]);
  const { user } = useUser();
  const { ClientId, CompCode } = user;
  useEffect(() => {
    const fetchInitData = async () => {
      const response = await fetch(
        `${API_URL}/facility/GetClientReportList/${user.ClientId}`
      ).then((res) => res.json());
      if (response.success) {
        setReportsDD([...response.data, { NAME: "FEEDBACK", ID: "0" }]);
      } else {
        alert(response.message);
      }
    };
    fetchInitData();
  }, []);
  const handleFetchReports = async () => {
    setIsLoading(true);
    const response = await fetch(
      `${API_URL}/facility/GetPivotReport/${selectedData.reportObj.ID}/${ClientId}/${fromDate}/${toDate}`
    ).then((res) => res.json());
    if (response.success) {
      setIsLoading(false);
      setTableData(response.data);
    } else {
      setIsLoading(false);
      alert("API CONNECTION ERROR");
    }
  };
  return (
    <>
      <div style={{ padding: "2rem 4rem" }}>
        <ReportsSelector4
          title="Reports Summary"
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          toDate={toDate}
          setToDate={setToDate}
          fromDate={fromDate}
          setFromDate={setFromDate}
          handleFetchReports={() => handleFetchReports()}
          reportTypeList={reportsDD}
        />
        {/* {isLoading ? <ThreeDotLoader /> : <ImageTable3 data={tableData} />} */}
        {/* <WashRoomChecklist /> */}
        {/* <HourGroupedTable data={sampleData} /> */}
        {/* <HourGroupedTable2 data={sampleData2} /> */}
        {/* {selectedData.reportObj && selectedData.reportObj.id === 6 ? (
          isLoading ? (
            <ThreeDotLoader />
          ) : (
            <ImageTable3 data={tableData} />
          )
        ) : isLoading ? (
          <ThreeDotLoader />
        ) : (
          <HourGroupedTable2 data={tableData} />
        )} */}
        {(ClientId === "1008" &&
          selectedData.reportObj &&
          selectedData.reportObj.ID === 7) ||
        ClientId === "1495" ||
        (ClientId === "11554" &&
          selectedData.reportObj &&
          selectedData.reportObj.ID === 7) ? (
          isLoading ? (
            <ThreeDotLoader />
          ) : (
            <ExportToExcelBTN2 data={tableData} />
          )
        ) : isLoading ? (
          <ThreeDotLoader />
        ) : (
          <ExportToExcelBTN2 data={tableData} />
        )}
      </div>
    </>
  );
};
export default ReportsSummary;
